import { Injectable } from '@angular/core';

import {
  ControlValidator,
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError
} from '../../types/validator.types';

@Injectable()
export class DigitalTypeValidator extends ControlValidator {
  type = ControlValidatorType.DigitalType;
  validateMoment = ControlValidateMoment.Input;

  validate(): ControlValidatorError {
    this.error = new ControlValidatorError(false, '');
    const validatorModel = this.model;
    const error = this.isValid(validatorModel);
    this.error = error;
    return this.error;
  }

  private isValid(validatorModel: any): ControlValidatorError {
    const value = this.control.model.value;
    // å¼ä¸ºç©ºåä¸æ ¡éª
    if (!value && value !== 0) {
      return new ControlValidatorError(true, '');
    }

    if (validatorModel.isInteger) {
      const integerReg = /^-?\d+$/;
      if (!integerReg.test(value)) {
        return new ControlValidatorError(false, 'ä¸æ¯æ´æ°');
      }
    }
    if (validatorModel.isFloat) {
      const decimalPalces = <number>validatorModel.float.decimalPlaces;
      let floatReg = /^(-?\d+)(\.\d+)?$/;
      let message = 'è¯·è¾å¥æµ®ç¹æ°';
      if (!isNaN(decimalPalces)) {
        floatReg = new RegExp(`^(-?\\d+)(\\.\\d{0,${decimalPalces}})?$`);
        message = `å°æ°ç¹ååªè½è¾å¥${decimalPalces}ä½`;
      }
      if (!floatReg.test(value)) {
        return new ControlValidatorError(false, message);
      }
    }
    return new ControlValidatorError(true, '');
  }
}
